export const navigateInApp = (path, { replace = false } = {}) => {
  if (typeof window === 'undefined' || !path) return;

  const currentPath =
    `${window.location.pathname}${window.location.search}${window.location.hash}`;

  if (currentPath !== path) {
    const method = replace ? 'replaceState' : 'pushState';
    window.history[method]({}, '', path);
  }

  window.dispatchEvent(new PopStateEvent('popstate'));
};
